import { render, staticRenderFns } from "./WebhookLogs.vue?vue&type=template&id=097d27b8"
import script from "./WebhookLogs.vue?vue&type=script&lang=js"
export * from "./WebhookLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports